(() => {
  "use strict";

  if (window.wolfCartCounterInitialized) return;
  window.wolfCartCounterInitialized = true;

  let refreshTimer;
  let refreshInProgress = false;
  let refreshAgain = false;

  function updateCounter(cart) {
    const count = Number(cart?.item_count);
    if (!Number.isFinite(count)) return;

    document.querySelectorAll("[data-cart-count]").forEach((element) => {
      element.textContent = String(count);
      element.setAttribute("data-cart-count", String(count));
    });

    document.querySelectorAll(".cart-link__bubble").forEach((bubble) => {
      bubble.classList.toggle("cart-link__bubble--visible", count > 0);

      let number = bubble.querySelector(".wolf-cart-bubble-count");

      if (!number) {
        number =
          bubble.querySelector(
            "[data-cart-count], .cart-link__bubble-num"
          ) || document.createElement("span");

        number.classList.add("wolf-cart-bubble-count");

        if (!bubble.contains(number)) {
          bubble.appendChild(number);
        }
      }

      number.textContent = String(count);
      bubble.setAttribute("aria-hidden", "true");
    });
  }

  async function refreshCounter() {
    if (refreshInProgress) {
      refreshAgain = true;
      return;
    }

    refreshInProgress = true;

    try {
      const root = window.Shopify?.routes?.root || "/";

      const response = await fetch(`${root}cart.js`, {
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Could not load the cart count.");
      }

      updateCounter(await response.json());
    } catch (error) {
      console.warn("Cart counter refresh failed:", error);
    } finally {
      refreshInProgress = false;

      if (refreshAgain) {
        refreshAgain = false;
        scheduleRefresh();
      }
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCounter, 100);
  }

  // Custom add-to-cart code and theme refresh requests.
  document.addEventListener("cart:refresh", scheduleRefresh);

  // Quantity changes and removals reported by the theme.
  document.addEventListener("cart:updated", (event) => {
    const cart = event.detail?.cart || event.detail;

    if (Number.isFinite(Number(cart?.item_count))) {
      updateCounter(cart);
    } else {
      scheduleRefresh();
    }
  });

  // Initial page load.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleRefresh, {
      once: true
    });
  } else {
    scheduleRefresh();
  }

  // Returning to a page using the browser's Back button.
  window.addEventListener("pageshow", scheduleRefresh);
})();